<ion-header>
  <app-mobile-toolbar [disabled]="isLoading" *ngIf="appService.isMobile()"></app-mobile-toolbar>
  <app-desktop-header [disabled]="isLoading" *ngIf="!appService.isMobile()" (showFaqSidebar)="showFaqSidebar = $event">
    >
  </app-desktop-header>
</ion-header>
<ion-content>
  <!--  Settings section-->
  <main class="flex flex-col md:h-full md:flex-row">
    <section
      *ngIf="!appService.isMobile() || showSettings"
      class="settings flex flex-col"
      [ngClass]="{ collapsed: menuCollapsed }"
      (elementResize)="settingsSectionHeight.set($event)"
      #settingsSection
    >
      <app-home-settings-section
        class="app-home-settings-section"
        [menuCollapsed]="menuCollapsed"
        [settings]="settings"
        [isLoading]="isLoading"
        (menuCollapseChanged)="menuCollapsed = !menuCollapsed"
        (settingSelectedEvent)="settingOptionSelect($event)"
        (closeSettingsEvent)="showSettings = false"
        [printProduct]="printProduct"
        [isMobile]="this.appService.isMobile()"
        [settingsSectionHeight]="settingsSectionHeight()"
      >
      </app-home-settings-section>
    </section>
    <section
      #mainContent
      class="mainContent flex flex-1 flex-col gap-5"
      [ngClass]="{ collapsed: menuCollapsed }"
      [ngStyle]="{
        'padding-top': files.length || appService.isMobile() ? '0' : '50px',
        'margin-left': menuCollapsed || appService.isMobile() ? '0' : settingsWidth + 'px',
      }"
    >
      <app-mobile-buttons-bar
        *ngIf="appService.isMobile()"
        [files]="files"
        [isLoading]="isLoading"
        (buttonClicked)="mobileBarButtonClicked($event)"
      ></app-mobile-buttons-bar>
      <div *ngIf="!files.length" class="mainContent_title raleway flex flex-row items-center justify-center gap-2.5">
        <h1>Imprime Online y Recibe en un Fly</h1>
        <img class="plane-logo" src="assets/icon/minilogo.svg" *ngIf="!appService.isMobile()" />
      </div>
      <app-current-printgroup-status-bar
        *ngIf="files.length && !this.appService.isMobile()"
        [files]="files"
        [printingGroupFiles]="printProduct.product.printingGroup.files"
        [printProduct]="printProduct"
        [class.menuCollapsed]="menuCollapsed"
        (uploadsCanceled)="cancelAllUploads()"
      >
      </app-current-printgroup-status-bar>
      <div
        cdkScrollable
        class="mainContent_container h-full"
        [ngStyle]="appService.isMobile() ? { 'padding-bottom': '280px' } : {}"
        (scroll)="appService.closeAllTooltips()"
      >
        <app-upload-files-options
          *ngIf="!files.length"
          [printProduct]="printProduct"
          [files]="files"
          (filesUploaded)="fileBrowseHandler($event)"
          (uploadCancel)="cancelAllUploads()"
        ></app-upload-files-options>
        <div [class.slider]="!printProduct?.product.printingGroup.files.length" *ngIf="slider$ | async; let sliders">
          <ng-container *ngIf="!printProduct.product.printingGroup.files.length">
            <section *ngIf="isLargeScreen">
              <app-slider [sliders]="sliders.home.banners1" [options]="slideOpts"></app-slider>
            </section>
            <section *ngIf="!isLargeScreen" class="banner2-section">
              <app-slider [sliders]="sliders.home.bannersMobile" [options]="slideOpts"></app-slider>
            </section>
          </ng-container>
        </div>
        <app-files-container
          *ngIf="printProduct?.product.printingGroup.files.length"
          [files]="files"
          [printingGroup]="printProduct?.product.printingGroup"
          [printProduct]="printProduct"
          [settings]="settings"
          [settingsChanged]="settingsChanged$ | async"
          [containerWidth]="mainContentWidth"
          (fileAction)="fileAction($event.event, $event.i)"
          [isLoading]="isLoading"
        >
        </app-files-container>
      </div>
    </section>
    <section *ngIf="!appService.isMobile()" class="summary">
      <app-home-summary-section
        [printProduct]="printProduct"
        [cartTotal]="getCartTotal()"
        [isLoading]="isLoading"
        [scrollHeight]="summaryScrollHeight"
      >
      </app-home-summary-section>
    </section>
    <input
      class="absolute"
      type="file"
      #fileDropRef
      id="fileDropRef"
      accept=".pdf"
      multiple
      (change)="fileBrowseHandler($event.target['files'])"
    />
    <app-mobile-home-folders
      *ngIf="appService.isMobile() && showFolders"
      [printProduct]="printProduct"
      [isLoading]="isLoading"
      (closeFoldersEvent)="showFolders = false"
    ></app-mobile-home-folders>
    <app-mobile-home-summary
      *ngIf="appService.isMobile()"
      [printProduct]="printProduct"
      [cartTotal]="getCartTotal()"
      [isLoading]="isLoading"
      (addingFiles)="fileDropRef.click()"
    ></app-mobile-home-summary>
    <div id="mobile-spacer" *ngIf="appService.isMobile()"></div>
  </main>
</ion-content>
